var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('polygon',{class:{ 'network-background': _vm.defaultClass, 'network-flow': _vm.calculateClass },attrs:{"points":_vm.polygon},on:{"click":function($event){return _vm.selectChannel(_vm.item, null, null, $event)}}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }